var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.75H13.9178L15.7823 5.61493C16.2033 4.05267 15.5793 2.39616 14.2322 1.5L6.43817 9.31087C6.30707 9.44225 6.20582 9.59688 6.13193 9.76332C6.08775 9.75943 6.04518 9.75 6 9.75H1.5V21H6C6.27461 21 6.52862 20.9208 6.75 20.792C6.97138 20.9208 7.22539 21 7.5 21H19.5086L22.5 13.5V11.25C22.5 10.4216 21.8284 9.75 21 9.75ZM3 19.5V11.25H6V19.5H3ZM21 13.2119L18.4919 19.5H7.5V10.3704L14.1932 3.66266C14.4049 4.10816 14.4698 4.62021 14.359 5.1221L12.5504 9.13344L11.5961 11.25H21V13.2119Z",
    fill: "#64B6AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenThumbUp);
export default __webpack_public_path__ + "static/media/green-thumb-up.e1a30e23c3d65454aee128a634ea6fd1.svg";
export { ForwardRef as ReactComponent };